import { useOrderFlow } from "../../../OrderFlowProvider/OrderFlowContext";
import { ModuleNames } from "../../../OrderFlowProvider/OrderFlowTypes";
export const useMarkdownModule = (sequenceNumber) => {
    var _a;
    const { store } = useOrderFlow();
    const moduleConfig = (_a = store.model.Flow.FlowModules.find((module) => module.ModuleName === ModuleNames.MARKDOWN &&
        module.Sequence === sequenceNumber &&
        module.Page === store.cart.currentPage)) === null || _a === void 0 ? void 0 : _a.ModuleConfig;
    return {
        MarkdownText: moduleConfig.Markdown,
    };
};
